module.exports = __webpack_public_path__ + "img/Forget-2.d5cbb664.svg";